export default __webpack_public_path__ + "static/media/Manage_users_icon.b83cc346.svg";